import classNames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { useCreateOrUpdatePlaylistModal } from '@frontend-mono/main/playlist/feature-playlist-modal'
import styles from './ModalListItem.module.scss'

const cx = classNames.bind(styles)

export type ModalListItemProps = {
  id: string
  title: string
  count: number
  onAdd: (id: string) => void;
}

export const ModalListItem = ({ id, title, count, onAdd }: ModalListItemProps) => {
  const { t } = useTranslation()
  const countText = () => {
    if (count === 0) {
      return t('Topic_playlist_count_0')
    }

    return t('Topic_playlist_count', { count })
  }
  const { openModal } = useCreateOrUpdatePlaylistModal({
    playlist: { id, title },
  })

  return (
    <div className={cx('container')}>
      <button
        className={cx('addButton')}
        onClick={() => onAdd(id)}
        type="button"
      >
        <div className={cx('title')}>{title}</div>
        <div className={cx('count')}>{countText()}</div>
      </button>
      <button className={cx('editButton')} onClick={openModal} type="button">편집</button>
    </div>
  )
}
